import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import PageHeader from 'Components/UI/PageHeader/PageHeader';
import BreadCrumb, { IBreadcrumbItem } from 'Components/UI/BreadCrumb';
import i18n from 'i18n';
import RateioEditor from './components/RateioEditor';

const getBreadCrumb = (): IBreadcrumbItem[] => [
  {
    description: i18n.t('faturamento:breadcrumbs.faturamento'),
    href: '/faturamento',
  },
  {
    description: i18n.t('faturamento:rateio.breadcrumb'),
    href: '/faturamento/rateio',
  },
];

// Página do cliente. O editor em si é compartilhado com a aba de rateio do /adm.
const Rateio: FC = () => {
  const { t } = useTranslation('faturamento');
  const navigate = useNavigate();

  return (
    <>
      <PageHeader name={t('rateio.pageTitle')} />
      <BreadCrumb breadcrumbs={getBreadCrumb()} />
      <RateioEditor onCancel={() => navigate('/faturamento')} />
    </>
  );
};

export default Rateio;
